export class CredentialsNotExistError extends Error {
  constructor() {
    super('Credenciais inválidas')
    this.name = 'CredentialsNotExistError'
  }
}
